var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClockFill2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM10.5 6C10.5 5.72386 10.2762 5.5 10 5.5C9.72389 5.5 9.50003 5.72386 9.50003 6V10.2857C9.50003 10.4751 9.60703 10.6482 9.77642 10.7329L12.6336 12.1615C12.8806 12.285 13.1809 12.1849 13.3044 11.9379C13.4279 11.6909 13.3278 11.3906 13.0808 11.2671L10.5 9.9767V6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockFill2);
export default __webpack_public_path__ + "static/media/icon-clock-fill2.2cc211ef8b8086ded81698f765f9a766.svg";
export { ForwardRef as ReactComponent };